import type { ReactNode } from 'react';

import { SentryRoute as Route } from '@occc-app/App/sentry';
import { ConfigGuard } from '@occc-app/App/guards';
import { ProtectedRoute } from '@occc-app/App/routes/ProtectedRoute';
import { driveChat } from '@occc/feat-feature-flag-control';
import { Feature } from '@occc/utils-access-control';
import { FlagBypass } from '@occc/data-flags';

import { DriveInsightsPage } from './drive-insights-page/drive-insights-page.component';
import { ChatHistoryPage } from './chat-history-page/chat-history.page';
import { DriveFeatureUnavailable } from './components/drive-feature-unavailable.component';

import { routeCreator } from '../drive-insights.router';

function driveInsightsGuards(content: ReactNode): ReactNode {
  return (
    <ConfigGuard
      isFeatureEnabled={(config) => config.driveInsights.enabled}
      fallback={<DriveFeatureUnavailable />}
    >
      <ProtectedRoute feature={Feature.DRIVE_INSIGHTS_VIEW} fallback={<DriveFeatureUnavailable />}>
        {content}
      </ProtectedRoute>
    </ConfigGuard>
  );
}

export const driveInsightsRoutes = (
  <Route path={routeCreator.base()}>
    <Route
      index
      element={
        <FlagBypass flag={driveChat} guards={driveInsightsGuards}>
          <DriveInsightsPage />
        </FlagBypass>
      }
    />
    <Route
      path='history'
      element={
        <FlagBypass flag={driveChat} guards={driveInsightsGuards}>
          <ChatHistoryPage />
        </FlagBypass>
      }
    />
  </Route>
);
